import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 36px;
  position: relative;
  border-radius: 10px;
  margin: 10px 0;

  > input {
    width: 100%;
    height: 100%;
    color: ${(props) => props.theme.colors.text.placeholder};
    background-color: ${(props) => props.theme.colors.inputSearchColor};
    font-size: 1.0rem;
    padding: 0 35px 0 16px;
    border-radius: 10px;
    border: 0;
    text-overflow: ellipsis;

    &::placeholder {
      color: ${(props) => props.theme.colors.text.default};
      text-transform: uppercase;
      font-size: 1.0rem;
      font-weight: 300;
    }
  }

  .icon {
    position: absolute;
    top: 5px;
    right: 10px;
    color: #10c2c5;
  }

  &.error {
    border: 1px solid red;

    .icon {
      color: red;
    }
  }
`;
